import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import AboutBrand from './components/AboutBrand';
import AboutTestimonials from './components/AboutTestimonials';
import ContactSection from './components/ContactSection';

function setMetaTag(name: string, content: string, isProperty = false) {
  const attr = isProperty ? 'property' : 'name';
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

export default function AboutPage() {
  useEffect(() => {
    document.title = '关于我们 - 今日吃瓜 - 品牌介绍与口碑评价';

    setMetaTag('description', '今日吃瓜创立于2024年，是国内领先的全网热门事件聚合平台。了解今日吃瓜的品牌故事、团队介绍、用户口碑评价，以及联系方式。加入吃瓜群众大家庭，一站式浏览全网热门事件。');
    setMetaTag('keywords', '今日吃瓜关于我们,今日吃瓜品牌介绍,今日吃瓜口碑评价,今日吃瓜联系方式,吃瓜平台介绍');

    setMetaTag('og:title', '关于我们 - 今日吃瓜 - 品牌介绍与口碑评价', true);
    setMetaTag('og:description', '了解今日吃瓜的品牌故事、团队介绍、用户口碑评价及联系方式。', true);
    setMetaTag('og:url', `${window.location.origin}/about`, true);

    // Schema.org Organization
    const ldJson = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '今日吃瓜',
      url: window.location.origin,
      description: '国内领先的全网热门事件聚合平台，结构化入口聚合全网热门事件、独家黑料曝光与每日吃瓜大赛。',
      foundingDate: '2024',
      contactPoint: {
        '@type': 'ContactPoint',
        email: 'admin@mxrxlb125.cn',
        contactType: 'customer service',
      },
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(ldJson);
    script.id = 'about-schema';
    document.head.appendChild(script);

    return () => {
      document.title = '今日吃瓜 - 全网热门事件 - 最新黑料独家曝光 - 每日吃瓜大赛 - 51在线入口实时更新';
      setMetaTag('description', '今日吃瓜网站通过结构化入口聚合全网热门事件、独家黑料曝光与每日吃瓜大赛，实时更新51在线资源，方便吃瓜群众一站式浏览最新动态。今日吃瓜热门大瓜必看、黑料曝光、吃瓜事件每日更新。');
      setMetaTag('keywords', '今日吃瓜,今日吃瓜热门大瓜必看,今日吃瓜黑料,今日吃瓜事件,今日吃瓜大赛,51今日吃瓜,今日吃瓜在线,今日吃瓜入口,51在线吃瓜,今日吃瓜合集,今日吃瓜爆料,今日吃瓜网');

      const existingScript = document.getElementById('about-schema');
      if (existingScript) existingScript.remove();
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <AboutBrand />
        <AboutTestimonials />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}
